import _styled from "styled-components";
import React, { useEffect } from 'react';
import { useImpressionRef } from '@noths/polaris-client-react-hooks';
import { getHashFromURL } from '@noths/polaris-client-utils';
import * as styles from "./Accordion.styles";
import { IconChevronUp } from "../../foundations/Iconography/IconChevronUp";
export var Accordion = function Accordion(_ref) {
  var children = _ref.children,
    id = _ref.id,
    onToggle = _ref.onToggle,
    onVisible = _ref.onVisible,
    _ref$open = _ref.open,
    open = _ref$open === void 0 ? true : _ref$open,
    title = _ref.title;
  var detailsRef = useImpressionRef(function () {
    return onVisible === null || onVisible === void 0 ? void 0 : onVisible();
  });
  var setOpen = function setOpen(value) {
    if (detailsRef.current) {
      detailsRef.current.setAttribute('open', String(value));
    }
  };
  var handleToggle = function handleToggle() {
    if (detailsRef.current) {
      onToggle === null || onToggle === void 0 || onToggle({
        open: detailsRef.current.open
      });
    }
  };
  var handleHashChange = function handleHashChange(_ref2) {
    var newURL = _ref2.newURL;
    if (getHashFromURL(newURL) === id) {
      setOpen(true);
    }
  };
  useEffect(function () {
    window.addEventListener('hashchange', handleHashChange);
    if (getHashFromURL(window.location.href) === id) {
      setOpen(true);
    }
    return function () {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);
  return /*#__PURE__*/React.createElement(_StyledDetails, {
    id: id,
    onToggle: handleToggle,
    open: open,
    ref: detailsRef,
    $_css: styles.details
  }, /*#__PURE__*/React.createElement("summary", null, /*#__PURE__*/React.createElement("div", null, title), /*#__PURE__*/React.createElement(IconChevronUp, {
    height: 16,
    width: 16
  })), children);
};
var _StyledDetails = /*#__PURE__*/_styled("details").withConfig({
  displayName: "Accordion___StyledDetails",
  componentId: "sc-1icteyv-0"
})(["", ""], function (p) {
  return p.$_css;
});